module.exports = __webpack_public_path__ + "img/9791159253744.55b583fd.jpg";